import { capitalize } from 'lodash'

export default string => capitalize(string || '')
